<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="processedDataSource"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="roll_no" slot-scope="roll_no">
          <span class="font-weight-bold">{{roll_no}}</span>
        </template>
        <template slot="name" slot-scope="name">
          <div>
            <a href="javascript:;" @click="showViewModal(name)" class="font-weight-bold">
              {{name}}
            </a>
          </div>
        </template>
        <template slot="studentCode" slot-scope="student_code">
          <div>
            <div class="font-weight-bold">{{student_code}}</div>
          </div>
        </template>
        <template slot="school_class" slot-scope="school_class">
          <span class="font-weight-bold">{{school_class}}</span>
        </template>
        <template slot="section" slot-scope="section">
          <span class="font-weight-bold">{{section}}</span>
        </template>
        <template slot="student_parents" slot-scope="student_parents">
          <span class="font-weight-bold text-wrap">{{student_parents.first_name }} {{ student_parents.last_name}}</span>
        </template>
<!--        <template slot="address" slot-scope="address">
          <span class="text-wrap">{{address.address ? address.address + ', ' + address.city : ''}}</span>
        </template>-->
        <template slot="phone" slot-scope="phone">
          <span class="font-weight-bold">{{phone.phone ? phone.country_code + phone.phone : ''}}</span>
        </template>
        <template slot="status" slot-scope="status">
          <a-tag
            :color="status == '0' ? 'volcano' : 'green'"
          >
            {{ status == '0' ? 'Inactive' : 'Active'}}
          </a-tag>
    </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- view -->
            <a-tooltip
              placement="top"
              title="View Student"
            >
              <a href="javascript:;" class="btn btn-sm btn-primary mr-2"
                @click="showViewModal(record)"
              >
                  <i class="btn-addon-icon fe fe-eye" />
              </a>
            </a-tooltip>
            <!-- Edit -->
            <a-tooltip
              placement="top"
              title="Edit Student"
            >
              <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light mr-2"
                @click="showEditModal(record)"
              >
                  <i class="btn-addon-icon fe fe-edit" />
              </a>
            </a-tooltip>
            <!-- Delete -->
            <a-tooltip
              placement="top"
              title="Delete Student"
            >
              <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger"
                @click="onDelete(record)"
              >
                  <i class="btn-addon-icon fe fe-trash" />
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <edit-student ref="editStudent" :session="session" @edited="handleTableUpdate"/>
    <student-info :rolesetting="rolesetting" ref="showStudent" :session="session" @updateTable="handleTableUpdate" @editClick="handleEditClickFromView"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditStudent from '@/components/student/Forms/Edit/index'
import StudentInfo from '@/components/student/Display/Single/index'
const columns = [
  {
    title: 'Roll No',
    className: 'text-left',
    dataIndex: 'enrollment_roll_no',
    // defaultSortOrder: 'descend',
    // sorter: (a, b) => a.enrollment[0].roll_no.localeCompare(b.enrollment[0].roll_no),
    sorter: true,
    scopedSlots: { customRender: 'roll_no' },
  },
  {
    title: 'Student Name',
    className: 'text-left text-gray-6',
    width: '20%',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    // sorter: (a, b) => a.first_name.localeCompare(b.first_name),
    sorter: true,
  },
  {
    title: 'S.Code',
    className: 'text-left',
    dataIndex: 'student_code',
    scopedSlots: { customRender: 'student_code' },
    // sorter: (a, b) => a.student_code.localeCompare(b.student_code),
    sorter: true,
  },
  {
    title: 'Class',
    className: 'text-left',
    dataIndex: 'enrollment[0].school_class.name',
    scopedSlots: { customRender: 'school_class' },
    // sorter: (a, b) => a.enrollment[0].school_class.name.localeCompare(b.enrollment[0].school_class.name),
  },
  {
    title: 'Section',
    className: 'text-left',
    dataIndex: 'enrollment[0].section.name',
    scopedSlots: { customRender: 'section' },
    // sorter: (a, b) => a.enrollment[0].section.name.localeCompare(b.enrollment[0].section.name),
  },
  {
    title: 'Father',
    className: 'text-left',
    dataIndex: 'student_parents[0]',
    scopedSlots: { customRender: 'student_parents' },
    // sorter: (a, b) => a.student_parents[0].first_name.localeCompare(b.student_parents[0].first_name),
  },
  /* {
    title: 'Address',
    className: 'text-left',
    dataIndex: 'contact',
    scopedSlots: { customRender: 'address' },
    // sorter: (a, b) => a.contact.address.localeCompare(b.contact.address),
  }, */
  {
    title: 'Phone No',
    dataIndex: 'contact',
    key: 'contact.phone',
    scopedSlots: { customRender: 'phone' },
    // sorter: (a, b) => a.contact.phone - b.contact.phone,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    filters: [
      { text: 'Active', value: '1' },
      { text: 'Inactive', value: '0' },
    ],
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]
function onChange(sorter) {
  console.log('params', sorter)
}
/* function getSorting(a, b) {
  if (a.enrollment[0].roll_no == null) {
    a.enrollment[0].roll_no = ''
  }
  if (b.enrollment[0].roll_no == null) {
    b.enrollment[0].roll_no = ''
  }
  return a.enrollment[0].roll_no.localeCompare(b.enrollment[0].roll_no)
} */
export default {
  name: 'StudentsTable',
  components: {
    EditStudent,
    StudentInfo,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    session: Number,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  watch: {
    // whenever question changes, this function will run
    loading: function () {
      this.selectedRowKeys = []
    },
  },
  computed: {
    processedDataSource() {
      return this.data.map(item => ({
        ...item,
        name: `${item.first_name} ${item.last_name}`,
        enrollment_roll_no: item.enrollment && item.enrollment.length > 0 ? item.enrollment[0].roll_no : 'N/A',
      }))
    },
  },
  methods: {
    handleTableChange: function (pagination, filters, sorter) {
      let sortColumn = sorter.field === 'name' ? 'first_name' : sorter.field
      this.$emit('updateTable', [sortColumn, sorter.order, filters])
    },
    onChange,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('selectChange', selectedRowKeys)
    },
    showViewModal: function(record) {
      this.$eventBus.$emit('openStudentShowModal', record.id)
    },
    handleEditClickFromView(studentId) {
      // this.$refs.editStudent.showModal(studentId)
      this.$eventBus.$emit('openStudentEditModal', studentId)
    },
    showEditModal: function(record) {
      // this.$refs.editStudent.showModal(record.id)
      this.$eventBus.$emit('openStudentEditModal', record.id)
    },
    handleTableUpdate: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete ${record.first_name} ${record.last_name}?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
